import React from 'react';

import Image from '../../library/image/image';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import CirclesRating, {
  FilledCircleColor
} from '../circles-rating/circles-rating';
import SnowyRoad from '../snowy-road/snowy-road';
import StoppingDistanceChart from '../stopping-distance-chart/stopping-distance-chart';

import { useMediaQuery } from '../../shared/hooks/hooks';

import { Maybe } from '../../shared/types/graphql-types';

import './snow-stopping-distance-info.scss';

interface SnowStoppingDistanceInfoProps {
  stoppingDistanceFeet: number;
  stoppingDistanceRating?: number;
  stoppingDistanceTitle?: Maybe<string>;
  stoppingDistanceTooltipText?: Maybe<string>;
}

function SnowStoppingDistanceInfo(props: SnowStoppingDistanceInfoProps) {
  const {
    stoppingDistanceFeet,
    stoppingDistanceRating,
    stoppingDistanceTitle,
    stoppingDistanceTooltipText
  } = props;

  const { isMinLg } = useMediaQuery();
  const showStoppingDistanceRating = Number(stoppingDistanceRating) > 0;

  return (
    <div>
      <div styleName="title">
        <div>
          <Image
            alt="Stopping Distance Icon"
            height="20"
            src="https://discounttire.scene7.com/is/content/discounttire/treadwell/treadwell_ic_stopping_distance.svg"
            styleName="icon"
            width="20"
          />
          <Typography weight="heavy">
            {stoppingDistanceTitle || 'Snow Stopping Distance'}
          </Typography>
          {stoppingDistanceTooltipText && (
            <Tooltip
              content={stoppingDistanceTooltipText}
              styleName="tooltip"
            />
          )}
        </div>
        {showStoppingDistanceRating && (
          <div styleName="circles-rating-container">
            <CirclesRating
              filledCircleColor={FilledCircleColor.GREY}
              rating={Number(stoppingDistanceRating)}
            />
            {stoppingDistanceRating!.toFixed(1)}
          </div>
        )}
      </div>
      <div styleName="chart-row-stopping-distance">
        <StoppingDistanceChart
          bottomOffset={isMinLg ? 8 : 0}
          renderTicks={(_, scaleMax, scaleMin) => (
            <>
              <SnowyRoad />
              <span style={{ left: 5 }} styleName="tick">
                {scaleMax}
              </span>
              <span style={{ right: '-2px' }} styleName="tick">
                {scaleMin}
              </span>
              <div styleName="stop-sign-extension" />
            </>
          )}
          scaleMax={120}
          scaleMin={0}
          styleName="stopping-distance-chart"
          value={stoppingDistanceFeet}
        />
      </div>
    </div>
  );
}

export default SnowStoppingDistanceInfo;
